var $ = require('jquery');
$(document).on("ready", function() {   
$('.moreless-button').click(function() {
  $('.more-text-company').slideToggle();
  if ($('.moreless-button').text() == "Read more") {
    $(this).text("Read less")
  } else {
    $(this).text("Read more")
  }
});
 });


